(() => {
  if (window.__BHD_V28_SHOPPING__) return;
  window.__BHD_V28_SHOPPING__ = true;
  const html = document.documentElement;
  const es = html.lang.startsWith('es');
  const tr = (en,sp) => es ? sp : en;
  const excluded = /\/(cart|checkout|policies)(\/|$)|\/pages\/(faq|faqs|frequently-asked-questions|contact|contact-us)(\/|$)/i.test(location.pathname);
  const ss = (k,v) => { try { sessionStorage.setItem(k,v); } catch (_) {} };
  const sg = k => { try { return sessionStorage.getItem(k); } catch (_) { return null; } };
  html.classList.remove('bhd-bundle-suggestion-dismissed', 'bhd-mobile-buy-visible');
  let frame;
  const isBusy = () => Boolean(document.querySelector('#bhd-pop-overlay.is-open,.mini-cart--open,body.mini-cart--opening,.bhd-global-bundle.is-open,header-drawer details[open],details.menu-drawer-container[open],search-modal details[open],dialog[open],[role="dialog"][aria-hidden="false"]') || document.body.classList.contains('mini-cart--open'));
  function sync() {
    const busy = isBusy();
    if(html.classList.contains('bhd-shopping-busy') !== busy) html.classList.toggle('bhd-shopping-busy',busy);
    const pin = document.querySelector('#bhd-pop-teaser');
    if (excluded) {
      if (pin) { pin.hidden = true; pin.style.display = 'none'; }
      const modal = document.querySelector('#bhd-pop-overlay');
      if (modal?.classList.contains('is-open')) document.querySelector('#bhd-pop-close')?.click();
    }
  }

  function schedule() { if (frame) return; frame = requestAnimationFrame(() => { frame = null; sync(); }); }
  document.addEventListener('click',event => {
    if (event.target.closest('[data-bhd-offer-reopen]')) {
      const overlay = document.querySelector('#bhd-pop-overlay');
      if (overlay && !excluded) document.querySelector('#bhd-pop-teaser-open')?.click();
      else location.href = (window.Shopify?.routes?.root || '/') + '?bhd_offer=1';
    }
    schedule();
  });
  document.addEventListener('change',schedule);

  const stateObserver = new MutationObserver(schedule);
  stateObserver.observe(document.body,{attributes:true,attributeFilter:['class']});

  const observeBusyNode = node => {
    if (!node || node.nodeType !== 1 || node.dataset?.bhdBusyObserved === 'true') return;
    node.dataset.bhdBusyObserved = 'true';
    stateObserver.observe(node,{attributes:true,attributeFilter:['class','hidden','disabled','open','data-cart-count','aria-hidden']});
  };

  const busySelector = '#bhd-pop-overlay,#BHDGlobalBundle,.mini-cart,header-drawer details,details.menu-drawer-container,search-modal details,dialog,[role="dialog"]';
  document.querySelectorAll(busySelector).forEach(observeBusyNode);

  new MutationObserver(mutations => {
    let relevant = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches?.(busySelector)) { observeBusyNode(node); relevant = true; }
        node.querySelectorAll?.(busySelector).forEach(child => { observeBusyNode(child); relevant = true; });
      });
      mutation.removedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches?.(busySelector) || node.querySelector?.(busySelector)) relevant = true;
      });
    });
    if (relevant) schedule();
  }).observe(document.body,{subtree:true,childList:true});

  sync();
  const root = document.querySelector('#bhd-pop-root');
  const first = document.querySelector('#bhd-pop-step-1');
  if (!root || !first) return;
  first.querySelector('label[for="bhd-pop-phone"]').textContent=tr('Mobile number','Número de celular');
  first.querySelector('#bhd-pop-title').textContent = tr('GET $5 OFF','RECIBE $5 DE DESCUENTO');
  first.querySelector('.bhd-pop-copy').textContent = tr('Which Mexican state would you like to see in a future drop?','¿Qué estado de México te gustaría ver en un próximo drop?');
  ['bhd-pop-state-decline','bhd-pop-phone-decline'].forEach(id=>{const el=document.getElementById(id);if(el)el.textContent=tr('Continue shopping','Seguir comprando');});
  const phone = document.getElementById('bhd-pop-phone');
  const phoneSubmit = document.getElementById('bhd-pop-phone-submit');
  phoneSubmit.textContent = tr('TEXT ME MY CODE','MÁNDAME MI CÓDIGO');
  const choice = document.getElementById('bhd-pop-email-choice');
  const alternative = document.getElementById('bhd-pop-email-alternative');
  if (!choice || !alternative) {
    if(new URLSearchParams(location.search).has('bhd_offer') && !excluded) document.querySelector('#bhd-pop-teaser-open')?.click();
    return;
  }
  alternative.querySelector('label').textContent=tr('Email address','Correo electrónico');
  alternative.querySelector('input').placeholder=tr('Email address','Correo electrónico');
  alternative.querySelector('button').textContent=tr('JOIN EMAIL DROP ALERTS','RECIBIR AVISOS POR CORREO');
  const notes=alternative.querySelectorAll('.bhd-pop-disclosure');
  notes[0].textContent=tr('Get future drop alerts by email. The $5 voucher is currently available through text signup.','Recibe avisos de próximos drops por correo. El cupón de $5 está disponible al registrarte por mensaje de texto.');
  notes[1].textContent=tr('By submitting, you agree to receive marketing emails from Barrio Hat Drop. You can unsubscribe at any time.','Al enviar, aceptas recibir correos de marketing de Barrio Hat Drop. Puedes darte de baja en cualquier momento.');
  choice.textContent = tr('Prefer email drop alerts?','¿Prefieres avisos de drops por correo?');
  choice.addEventListener('click',()=>{
    alternative.hidden = !alternative.hidden;
    document.querySelector('#bhd-pop-step-1 .bhd-pop-phone-field').hidden = !alternative.hidden;
    document.getElementById('bhd-pop-phone-submit').hidden = !alternative.hidden;
    first.querySelector('label[for="bhd-pop-phone"]').hidden = !alternative.hidden;
    const disclosure = first.querySelector(':scope > .bhd-pop-disclosure');
    if (disclosure) disclosure.hidden = !alternative.hidden;
    choice.textContent = alternative.hidden?tr('Prefer email drop alerts?','¿Prefieres avisos de drops por correo?'):tr('Prefer texts?','¿Prefieres mensajes de texto?');
  });
  const submit = document.getElementById('bhd-pop-alert-email-submit');
  const email = document.getElementById('bhd-pop-alert-email');
  const message = document.getElementById('bhd-pop-alert-email-message');
  let pending = false;
  submit.addEventListener('click',()=>{
    let states=[]; try { states=JSON.parse(sg('bhd_popup_v10_states')||'[]'); } catch (_) {}
    const state=states.join(', ');
    if (!states.length) { message.textContent=tr('Choose a state preference first.','Primero elige un estado.'); message.classList.add('is-visible');return; }
    if (!email.validity.valid || !email.value.trim()) {message.textContent=tr('Enter a valid email address.','Ingresa un correo válido.');message.classList.add('is-visible');return;}
    if(pending)return;
    pending=true;submit.disabled=true;
    const form=document.createElement('form');form.method='POST';form.action='https://bhd-lead-capture-direct-v2.vercel.app/api/lead';form.target='bhd-pop-iframe';form.hidden=true;
    const payload={action:'email_only',email:email.value.trim(),state,states:JSON.stringify(states),form_id:'popup_lead_capture',form_type:'popup',form_location:'sitewide',source_tag:'BHD | Source | Popup',intent_tag:'BHD | Intent | Release Alert',channel_tag:'BHD | Channel | Email',flow_tag:'BHD | Flow | Drop',taxonomy_tags:'BHD | Lead, BHD | Channel | Email, BHD | Source | Popup, BHD | Intent | Release Alert, BHD | State | '+state,website:''};
    for(const [name,value] of Object.entries(payload)){const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.appendChild(input);}
    document.body.appendChild(form);form.submit();form.remove();
    setTimeout(()=>{if(pending){pending=false;submit.disabled=false;message.textContent=tr('We could not confirm your signup. Please try again.','No pudimos confirmar tu registro. Inténtalo de nuevo.');message.classList.add('is-visible');}},15000);
  });
  window.addEventListener('message',event=>{
    if(!pending || event.origin!=='https://bhd-lead-capture-direct-v2.vercel.app' || event.source!==document.getElementById('bhd-pop-iframe').contentWindow)return;
    const result=event.data?.payload;if(!result)return;
    pending=false;submit.disabled=false;
    message.textContent=result.ok?tr('You’re on the email drop alert list.','Ya estás en la lista de avisos por correo.'):(result.error||tr('Please try again.','Inténtalo de nuevo.'));
    message.classList.add('is-visible');
    if(result.ok){ss('bhd_v28_email_captured','1');submit.hidden=true;}
  });
  if(new URLSearchParams(location.search).has('bhd_offer') && !excluded) document.querySelector('#bhd-pop-teaser-open')?.click();
})();
